import React, { useState } from 'react'

import { DeleteClient } from 'store/ClientsApiClient'
import { trackPromise } from 'react-promise-tracker'
import LoadingWrapper from 'components/LoadingWrapper'
import styled from 'styled-components'

const CancelLink = styled.span`
    padding-left: 15px;
`

const DeleteClientModal = ({ clientId, close, refreshList, firstName, lastName }) => {
    const PromiseArea = 'delete-modal'
    const [error, setError] = useState(null)

    const Delete = () => {
        trackPromise(
            DeleteClient(clientId)
                .then(() => {
                    close()
                    refreshList()
                })
                .catch(ex => {
                    console.error(ex)
                    setError('There was a problem deleting the client')
                }),
            PromiseArea
        )
    }

    return (
        <>
            <div id="modal-cover"></div>
            <div id="delete-modal" className="modal">
                <LoadingWrapper area={PromiseArea}>
                    <p>
                        Are you sure you wish to delete {firstName} {lastName} from your records?
                        You will not be able to get their information back at a later date.
                    </p>
                    {error && <p>{error}</p>}
                    <span onClick={Delete} className="btn arrow-btn">
                        DELETE FOREVER
                    </span>
                    <CancelLink onMouseDown={close}>CANCEL</CancelLink>
                </LoadingWrapper>
            </div>
        </>
    )
}

export default DeleteClientModal
